import * as React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { withRouter, WithRouterProps } from "./WithRouter";
import { ItemType } from "antd/lib/breadcrumb/Breadcrumb";

interface BreadcrumbsProps extends WithTranslation, WithRouterProps {
  config: { [key: string]: string }[]; // [key] = RegExp, [value] = string, title for breadcrumb
  className?: string;
}
export const BreadcrumbsGenerator = withTranslation(I18N_NS.ADMIN)(
  withRouter(
    class extends React.Component<BreadcrumbsProps> {
      getBreadCrumbsItems = (): ItemType[] => {
        const pathName = this.props.location.pathname;

        return this.props.config.reduce((prev, curr) => {
          const routePath = Object.keys(curr)[0];
          const routeName = Object.values(curr)[0];
          const { t } = this.props;
          // A function return RegExp object with native properties for use.
          // For example: we need initial value of matching,
          // we can get it from: somestr.match(new RegExp(somesrc)).[0]
          const customRegExp = (src: string): RegExpMatchArray | null => {
            return pathName.match(new RegExp(src));
          };

          if (customRegExp(routePath)) {
            const isActiveBreadcrumb = pathName.replace(customRegExp(routePath)[0], "") ? (
              <Link to={customRegExp(routePath)[0]}>{t(routeName)}</Link>
            ) : (
              t(routeName)
            );

            prev.push({ key: routePath, title: isActiveBreadcrumb });
          }
          return prev;
        }, []);
      };

      render() {
        return (
          <Breadcrumb
            separator=">"
            className={this.props.className ? this.props.className : "admin-breadcrumbs"}
            items={this.getBreadCrumbsItems()}
          ></Breadcrumb>
        );
      }
    }
  )
);
